// extracted by mini-css-extract-plugin
module.exports = {"container":"_1dz7I8G1YGXiXTu3lq-uDa","visible":"_3TT-3pvLbvPZJsByKxFGSH","cancelBtn":"_1nCnUdsYxgLXOYufwrH8Zg","icon":"_188FycgYjK2iz2bpq1FonH","saveBtn":"ALUixAobyuAr_UL0S7yBg"};